export const env = import.meta.env.REACT_APP_ENV! as 'prod' | 'staging' | 'dev'

export const removeEmptyItems = (obj: object): object => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([k, v]) => k === 'metadataFile' || (v !== null && v !== ''))
      .map(([k, v]) => [k, isObject(v) ? removeEmptyItems(v) : isArray(v) ? v.filter((vv: unknown) => vv !== null) : v]),
  )
}

export const isArray = (value: unknown) => {
  return Array.isArray(value)
}

export const isObject = (value: unknown) => {
  return value === Object(value) && !isArray(value) && typeof value !== 'function'
}

const dec2hex = (dec: number) => {
  return dec.toString(16).padStart(2, '0')
}

export const generateId = (len: number = 16) => {
  const arr = new Uint8Array(len / 2)
  window.crypto.getRandomValues(arr)
  return Array.from(arr, dec2hex).join('')
}

export const dateDiffInDays = (a: Date, b: Date) => {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())

  return Math.floor((utc2 - utc1) / _MS_PER_DAY)
}

export const humanFileSize = (bytes: number, si: boolean = false, decimalPoint: number = 1) => {
  const thresh = si ? 1000 : 1024

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B'
  }

  const units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  let u = -1
  const r = 10 ** decimalPoint

  do {
    bytes /= thresh
    ++u
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1)

  return bytes.toFixed(decimalPoint) + ' ' + units[u]
}

export const parseMetadata = (metadata?: string) => {
  if (!metadata) {
    return {}
  }
  try {
    return JSON.parse(metadata)
  } catch {
    console.debug(`Could not parse metadata: ${metadata}`)
  }
  return {}
}

export const isValidEmail = (email: string) => email.match(/\S+@\S+\.\S+/) !== null

export const splitCamelCase = (value: string) => {
  return value
    .replace(/([A-Z])/g, ' $1')
    .toLowerCase()
    .replace(/^./, (value: string) => value.toUpperCase())
    .trim()
}

/**
 * Converts a duration from hours to seconds.
 *
 * @param {number} hours - The duration in hours.
 * @returns {number} The duration converted to seconds.
 */
export const toSeconds = (hours: number): number => {
  return Math.floor(hours * 3600)
}

export const stripToText = (input: string): string => {
  const inertBody = document.implementation.createHTMLDocument('').body
  inertBody.innerHTML = input
  return inertBody.textContent || ''
}
